<template>
  <div>
    <div class="loader-cont">
      <div class="loader-cont__wrapper">
        <div class="loader"></div>
        <div class="loader_text">{{ getTranslations.home_loader_please_wait }}</div>
      </div>
    </div>

    <maintenance v-if=serverUnderMaintenance></maintenance>
  </div>
</template>

<script>
/* eslint no-console: "off", no-use-before-define: ["error", { "variables": false }] */
import { mapState, mapGetters, mapMutations } from 'vuex';
import { Howl } from 'howler';
import webSocket from '@/common/webSocket';
import auth from '@/common/auth';
import { ParseResponseMixin, GameMixin2 } from '@/common/mixins/game';
import Maintenance from '@/components/home/modals/Maintenance';

export default {
  name: 'searching-opponent',
  mixins: [ParseResponseMixin, GameMixin2],
  components: {
    Maintenance,
  },
  watch: {
    stompClient: {
      handler() {
        console.log('change to stompclient!');
        // eslint-disable-next-line
        console.log('connected: ' + this.stompClient.connected);
        if (this.stompClient.connected) this.hasConnectAtLeastOneTime = true;
        else if (this.hasConnectAtLeastOneTime) this.OnStompClientFailure('lock screen error');
      },
      deep: true,
    },
  },
  data() {
    return {
      hasConnectAtLeastOneTime: false,
      stompClient: null,
      subscription: null,
      timer: null,
      connectionTimer: null,
      opponentsAvatars: [],
      serverUnderMaintenance: false,
      searchSound: new Howl({
        src: ['static/sounds/SearchForOpponent.ogg', 'static/sounds/SearchForOpponent.mp3'],
        loop: true,
      }),
    };
  },
  created() {
    console.log('in SearchingOpponent created hook');
    // resetting game state
    this.resetGameState();
    this.setGameInProgress(true);
    this.setTransitionOnlyForSearchingToOpponent(true);
    this.stompClient = webSocket.getGameStompClient();
    if (this.stompClient === null || !this.stompClient.connected) {
      this.stompClient = webSocket.createNewStompClient('/gameData');
    }
    console.log('this.stompClient:', this.stompClient);
    this.findOpponent();
  },
  mounted() {
    console.log('in SearchingOpponent mounted hook');
    if (this.soundsOn) {
      this.searchSound.play();
    }
  },
  methods: {
    ...mapMutations('game', [
      'setTransitionOnlyForSearchingToOpponent',
      'resetGameState',
      'setGameInProgress',
      'setGameID',
      'setPlayersDetails',
    ]),
    OnStompClientFailure(error) {
      console.log(error);
      window.location.reload();
    },
    findOpponent() {
      const stompSuccess = (frame) => {
        clearTimeout(this.connectionTimer);
        // console.clear();
        console.log(`In SearchingOpponent component: ${frame}`);
        console.log(`Subscribing to channel: /topic/gameFound/${this.userDetails.msisdn}`);
        this.subscription = this.stompClient.subscribe(`/topic/gameFound/${this.userDetails.msisdn}`, (response) => {
          console.log('[SearchingOpponent] Inside gameFound response');
          // parse server response and return if any errors occur
          const responseData = this.parseServerResponse(response.body);
          if (responseData === null) {
            return;
          }
          console.log('responseData:', responseData);
          if (responseData.gameStateEnum === 'NEW_GAMES_BLOCKED') {
            this.serverUnderMaintenance = true;
            this.$nextTick(() => {
              this.showHideModal();
            });
          } else if (responseData.gameStateEnum === 'OPPONENT_FOUND') {
            this.subscription.unsubscribe();
            console.log('gameStateEnum: OPPONENT_FOUND');
            this.saveResponseData(responseData);
            clearInterval(this.timer);
            this.normalTransition = true;
            this.searchSound.stop();
            console.log('going to opponent found page...');
            this.$router.replace('/opponentFound');
          }
        }, (errorResponse) => {
          console.error(`Error response: ${errorResponse}`);
        });
        this.sendUserMSISDN();
      };

      const stompFailure = (error) => {
        console.error(`Connect failed with the following error: ${error.headers.message}`);
        console.log(this.$router.currentRoute);
        if (this.$router.currentRoute.path === '/searchingOpponent') {
          console.info('Lost connection to WebSocket! Reconnecting in 3 seconds...');
          clearTimeout(this.connectionTimer);
          this.connectionTimer = setTimeout(() => {
            this.stompClient = webSocket.createNewStompClient('/gameData');
            connect();
          }, 3000);
        }
      };

      const connect = (() => {
        if (!this.stompClient.connected) {
          this.stompClient.connect({ Authorization: auth.getJwt() }, stompSuccess, stompFailure);
        } else {
          stompSuccess();
        }
      })();
    },
    sendUserMSISDN() {
      console.info(`==> Sending user msisdn: ${encodeURIComponent(this.userDetails.msisdn)}...`);
      this.stompClient.send('/duel/randomMatchingForScore', { Authorization: encodeURIComponent(this.jwtInVuex) }, {});
    },
    saveResponseData(responseData) {
      this.setGameID(responseData.gameId);
      this.setPlayersDetails({
        homePlayerMSISDN: responseData.homeUserDetails.msisdn,
        homePlayerUsername: responseData.homeUserDetails.username,
        homePlayerAvatar: responseData.homeUserDetails.avatar,
        homePlayerLevel: responseData.homeUserDetails.currentLevel,
        awayPlayerMSISDN: responseData.awayUserDetails.msisdn,
        awayPlayerUsername: responseData.awayUserDetails.username,
        awayPlayerAvatar: responseData.awayUserDetails.avatar,
        awayPlayerLevel: responseData.awayUserDetails.currentLevel,
      });
    },
    showHideModal() {
      /* eslint-disable */
      $('.modal-close, .modal-overlay').click(() => {
        $('.modal, .modal-overlay').fadeOut();
        this.$router.push('/home');
      });

      $('.modal,.modal-overlay').fadeIn(200);
      /* eslint-enable */
    },
  },
  computed: {
    ...mapState('profile', [
      'jwtInVuex',
    ]),
    ...mapState('common', [
      'userDetails',
      'avatarGrouping',
      'soundsOn',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/game/SearchingOpponent.vue